module.exports = __webpack_public_path__ + "img/grooming7.41fd1947.jpg";